export default {
  namespaced: true,
  state: {
    selectingLocale: null,
    locales: null,
    pageUpdating: false,
  },
  mutations: {
    SET_LOCALES(state, data) {
      state.locales = data
      state.selectingLocale = data[0].code
    },
    SET_SELECTING_LOCALE(state, data) {
      state.selectingLocale = data
    },
    CHANGE_LANGUAGE_ABLE(state){
      state.pageUpdating = false;
    },
    CHANGE_LANGUAGE_DISABLE(state){
      state.pageUpdating = true;
    },
  },
  actions: {
    setLocales({ commit }, data) {
      commit('SET_LOCALES', data)
    },
    setSelectingLocale({ commit }, data) {
      commit('SET_SELECTING_LOCALE', data)
    },
    changeLanguageAble({commit}){
      commit('CHANGE_LANGUAGE_ABLE');
    },
    changeLanguageDisable({commit}){
      commit('CHANGE_LANGUAGE_DISABLE');

    },
  }
}